export enum QueryOperation {
    Equal = "eq",
    NotEqual = "ne",
    LessThan = "lt",
    LessThanOrEqual = "lte",
    GreaterThan = "gt",
    GreaterThanOrEqual = "gte",
    Contains = "contains"
}

export enum QueryBooleanOperation {
    And = "and",
    Or = "or",
    Not = "not"
}

export class  QueryExpression {
    Field : string ;
    Operator ?: QueryOperation ; // Default to EQUAL
    Value : string ;
}

export class DataSourceQuery {
    Expressions :  QueryExpression[] ;
    BooleanOperator ?: QueryBooleanOperation ;
    SubExpressions ?: DataSourceQuery[] ; // reserved
    Custom ?: any ; // Reserved for custom query information passed to data source
}